import Layout from '../components/Layout/Layout';
import SingleSignOn from '../components/SingleSignOn/SingleSignOn';

export default function CheckoutApp() {
	return (
		<Layout>
			<SingleSignOn />
		</Layout>
	);
}
